import { ProductType } from "../contexts/OrderContext";
import { isVisibleByHour } from "./visibilityHour";

export type ProductVisibilityCatalogItem = {
  id: number;
  initialHour?: string | null;
  finalHour?: string | null;
};

export function getProductVisibilityHours(
  product: ProductType,
  catalog?: ProductVisibilityCatalogItem[]
): { initialHour?: string | null; finalHour?: string | null } {
  if (product.initialHour || product.finalHour) {
    return {
      initialHour: product.initialHour ?? null,
      finalHour: product.finalHour ?? null,
    };
  }

  const catalogItem = catalog?.find((item) => item.id === product.id);

  return {
    initialHour: catalogItem?.initialHour ?? null,
    finalHour: catalogItem?.finalHour ?? null,
  };
}

export function isProductAvailableByVisibilityHour(
  product: ProductType,
  catalog?: ProductVisibilityCatalogItem[]
): boolean {
  const hours = getProductVisibilityHours(product, catalog);
  return isVisibleByHour(hours.initialHour, hours.finalHour);
}

export function splitProductsByVisibilityHour(
  products: ProductType[],
  catalog?: ProductVisibilityCatalogItem[]
): {
  validProducts: ProductType[];
  removedProducts: ProductType[];
} {
  const validProducts: ProductType[] = [];
  const removedProducts: ProductType[] = [];

  products.forEach((product) => {
    if (isProductAvailableByVisibilityHour(product, catalog)) {
      validProducts.push(product);
    } else {
      removedProducts.push(product);
    }
  });

  return { validProducts, removedProducts };
}
